import BaseService from './base.service';

export default class DiscountsService extends BaseService {
  getDiscounts(criteria) {
    const queryString = this.getQueryString(criteria);
    return this.get(`/discounts${queryString}`);
  }

  getAllDiscounts() {
    return this.get('/discounts/all');
  }

  updateDiscount(id, payload) {
    return this.put(`/discounts/${id}`, payload);
  }

  createDiscount(payload) {
    return this.post('/discounts', payload);
  }

  removeDiscount(id) {
    return this.delete(`/discounts/${id}`);
  }
}
